import React, { Fragment } from "react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Navigation, Pagination, Autoplay]);
import type { NextPage } from "next";
import Image from "next/image";
import Layout from "../layout/layout";
import banner from "../assets/images/greenflame.jpg";

import styles from "../styles/kishalaya.module.scss";

const Greenflame: NextPage = () => {
  return (
    <Layout>
      <div className={styles.csr_banner}>
        <Image src={banner} alt="" width={1920} height={608} />
      </div>
      <section>
        <div className={styles.table}>
          <div className="container">
            <div className="table-responsive">
              <table className="mt-5">
                <tbody>
                  <tr>
                    <td colSpan={2} className={styles.tab_h}>
                      Project-Green Flame
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      SENCO GOLD AND DIAMONDS CSR INITIATIVES FOR CREATING LESS
                      POLUTING RURAL KITCHEN
                    </td>
                  </tr>
                  <tr>
                    <th>Executed By</th>
                    <td>PC SEN CHARITABLE TRUST</td>
                  </tr>
                  <tr>
                    <th>Project</th>
                    <td>IMPROVED DOMESTIC CHULA(IDC)</td>
                  </tr>
                  <tr>
                    <th>Project Insight</th>
                    <td>
                      The concept of Improved Domestic or Community Chula has
                      been designed by one of our beneficiary NGO, Alinan
                      Ramakrishna Viveka Yuva Sangha, which has overall thermal
                      efficiency of 23.08% and overall power rating of 1.33KW,
                      and has been certified by School of Energy Studies,
                      Jadavpur University. Since 2001, more than 30000 IDC and
                      200 ICC has been installed in different rural homes,
                      thereby helping Rural Women to have less polluting
                      kitchen.
                    </td>
                  </tr>
                  <tr>
                    <th>Installation Target</th>
                    <td>1000 Homes</td>
                  </tr>
                  <tr>
                    <th>Duration</th>
                    <td>(2023-24, 2024-25, 2025-26)</td>
                  </tr>
                  <tr>
                    <th>Project Implementation Plan</th>
                    <td>
                      We started with installing 35 Chullas at homes of the 35
                      children who are studying at the creche cum pre-primary
                      education centre. More interest were created among the
                      villagers and the other families also requested us to
                      install Chullas at their homes. We increased it to 100
                      units. Further 100 homes have been increased at Mayachar
                      and 150 units to be installed at {"'"}Chandakhali{"'"} of
                      Kakharada Gram Panchyat and Banomara in Dalhara G.P under
                      Sahid Matangini Block of Purba Medinipur, inhabited by
                      more than 200 underprivileged families who would be
                      benefitted by our IDC.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table-responsive">
              <table className="mt-5">
                <tbody>
                  <tr>
                    <td colSpan={5} className={styles.tab_h}>
                      Implementation Schedule
                    </td>
                  </tr>
                  <tr>
                    <th>Sl No</th>
                    <th>Year</th>
                    <th>Location</th>
                    <th>Total No of Units to be installed</th>
                    <th>Type of Chulla</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>2023-24</td>
                    <td>Mayachar(Mahishadal Block,Purba Medinipur)</td>
                    <td>200</td>
                    <td>IDC</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td></td>
                    <td>
                      {"'"}Chandakhali{"'"} of Kakharada Gram Panchyat and
                      Banomara in Dalhara G.P under Sahid Matangini Block of
                      Purba Medinipur
                    </td>
                    <td>150</td>
                    <td>IDC</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td></td>
                    <td>Anandaangar Development Society(Purulia)</td>
                    <td>2</td>
                    <td>ICC</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td></td>
                    <td>Mayachar(Mahishadal Block,Purba Medinipur)</td>
                    <td>1</td>
                    <td>ICC</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td></td>
                    <td>
                      Vivekananda School &amp; Skill Development Centre, Bamon
                      Mollor Chowk, South 24 Parganas
                    </td>
                    <td>1</td>
                    <td>ICC</td>
                  </tr>
                  <tr>
                    <td colSpan={3} className="text-end">
                      <strong>Total</strong>
                    </td>
                    <td>354</td>
                    <td>0</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Greenflame;
